// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getFirestore} from "firebase/firestore"
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBs_LZhM5Ij0J1-knpAvIF5StF3KtX_hlE",
  authDomain: "pentagon-ac4f2.firebaseapp.com",
  projectId: "pentagon-ac4f2",
  storageBucket: "pentagon-ac4f2.firebasestorage.app",
  messagingSenderId: "60674020237",
  appId: "1:60674020237:web:ff329bbeb52126ae4e63c4",
  measurementId: "G-FNCKW6H7Y4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const storageBucket = firebaseConfig.storageBucket;
